import debounce from '../Components/Utils/debouncer.js';

const clickOutside = debounce(() => { document.body.click(); }, 100, true);
function focusNextActiveElement() {
    const focusableElements = 'input, button, select, textarea, [tabindex]:not([tabindex="-1"])';
    const focusable = Array.from(document.querySelectorAll(focusableElements));
    let nextElement = focusable[0]; // Loop back to the first element
    if (document.activeElement) {
        const index = focusable.indexOf(document.activeElement);
        nextElement = focusable[index + 1];
    }
    nextElement === null || nextElement === void 0 ? void 0 : nextElement.focus();
}
const primary = getComputedStyle(document.documentElement).getPropertyValue('--primary');
const newPrimary = getComputedStyle(document.documentElement).getPropertyValue('--new-primary');
const primaryLight = getComputedStyle(document.documentElement).getPropertyValue('--primary-light');
const newPrimaryLight = getComputedStyle(document.documentElement).getPropertyValue('--new-primary-light');
function changeCustomProperty(name, value, element = document.documentElement) {
    element.style.setProperty(name, value);
}
function restoreLegacyColors() {
    changeCustomProperty('--primary', primary);
    changeCustomProperty('--primary-light', primaryLight);
}
function restoreNewColors() {
    changeCustomProperty('--primary', newPrimary);
    changeCustomProperty('--primary-light', newPrimaryLight);
}

export { changeCustomProperty, clickOutside, focusNextActiveElement, restoreLegacyColors, restoreNewColors };
